import { render, staticRenderFns } from "./GoodsDanFa.vue?vue&type=template&id=0035ee72&scoped=true&"
import script from "./GoodsDanFa.vue?vue&type=script&lang=js&"
export * from "./GoodsDanFa.vue?vue&type=script&lang=js&"
import style0 from "./GoodsDanFa.vue?vue&type=style&index=0&id=0035ee72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0035ee72",
  null
  
)

export default component.exports